import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

toast.configure();


export const getFileSetting = (callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/files`, {},token, dispatch).then((response) => {
    if (response) {
      dispatch({ type: "FILE_SETTING", data: response?.docs });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

